export const environment = {
    production: true,
    apiUrl: 'https://dev-csat.easternenterprise.com/api'
};
